import type { CustomProduct } from "@apptus/esales-api";
import isProductExploded from "./isProductExploded";
import isVariantExploded from "./isVariantExploded";

export default function isExploded(product: CustomProduct) {
  return isProductExploded(product) || isVariantExploded(product);
}
